var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categorySection h100"},[(_vm.categoryData.length > 0)?_c('div',[_c('Category',{attrs:{"data":_vm.categoryData},on:{"click":_vm.categoryClick}}),_c('div',{staticStyle:{"height":"100px"}})],1):_vm._e(),_c('DefaultDisplayStage',{attrs:{"fetching":_vm.fetching,"error":_vm.error,"nodata":_vm.nodata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }